var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNormalWallpaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 80,
    viewBox: "0 0 75 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 30,
    r: 30,
    fill: "#DDE0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1419_34383)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 70,
    height: 70,
    fill: "url(#pattern0_1419_34383)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1419_34383",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1419_34383",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1419_34383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0 10)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1419_34383",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAE3UlEQVRoge2Zy29UVRzHP+fMTKcDthNoFcZAEAI0+AhCZwEr4yNRjAUXoOLCrVs3rtREV5qYuHJh4h+AQlQMgvgIujGReFWIhEChRRSsFHm0pdOZuXfuz8W9096Zuedepp0ZWPSb3Nxzz/mdme/v8T2/ecAiFrEgqDgDETR/stN1eVEptgP3+UtXRPhZaz7hAQ4phdtequGIdEDOs140+4B8uMHs/Rcl7FUbGGkxv1gYHZDzrBaNxVzE/YW6uz8WuKJdBtUAl1tP04ykacFN8J4Sn7xP1jmVo/xpHhSkX7DQD44FHVnhwrvAK60mKf+whCmWqAH+q1/Tpk3KZQcCuL4DAuX9eWQig9zMUNo/ODsfsHu2pcTP0SujvC5F/pIUf4TZGDOAsMy/e0GWEBu3xh6gb55c515GUIyw3dW8LF42e6LsjQ5Ifa0LpPdYlA7kASG9x2rQwbxJj5BF87grPCUXeA7Nmtjj0YfRrjKMhBI0zFWHyYdiTrZL9FFkAM1WV7FFCVuBR4BEHFm9rvG1jRmYeWeI9G4LvWksljQClTM57M/yyIVDj+HSh6IPod9V9CtYA6wD1kmZbFV5agFZi3VAbmYoHRgk89ZXRtLBu/15HpnMIMKPs3FSt9EpFwiziKtwzaQbxncA5mM0W6Brt+WJue44JWSua5eFys50gHIdT9OCc6pRxJUzOewvvEbW9byF3jjmLQXsEtl2UQ0XsTEDDdEWsA/6dT6RoXxwEBHmMlS9OoyoRhZe81Hrd8ABcwYC9V2NdGqnV+eqt0BqlxWujQ7DqAH7d59OE80MINHfMm4NaEoDpfeHcM/mQk+c+jkRcIZzFD8YCtVOy64wp0wOyEQG+8vBSNKzInbBOZyHqUzHHYhvZIHNwtz4bmlm5kbWWyA1ZNVGOuJK7bCgd6bjGTCKuHw8sMUfVYZzOEe8RpbaYaHXN37QS9Z+AW0p9Mb5NLKAeJ2v/TqfzGAfmdOHCIhLTUfuFKIbWdg9aNL4jazjeojOQN3RmXrGgp4Z6Cl4NR91xN5xDfyEIHUnT3BsmEutNIZkwdCbmmlkHw7hns/VRiCimbkjOcofDaGgbVeoU0Z3JzPYR0MaWcglAs53ebh1NzYyg1Clfs703GaYM9BTIPV0rVAbmlqgpJJP+ALvMIwiLv0QEDHEireK9P0tZFcH9XATP6tIoO7sq+CMK5xJENubVylIZiHZL6T6Gvd0CmYNuODOQOG0ojLVuCwlKI9DeVyhe2DJgKDT3D0acItw67dG8k5F4VRqM+lOwfRJhZTawrGKkDBGZKA0qrxy8XGrpDl3pZvpkufz0rTLhhVF7kl7x5TYULyoyKxtWwq+CZs0ZsC+Xvt8dmyOPMB0STP8b3ftnhu0qwecRXitKQfE4YZpbdamLtjafCjPF6eAVymwRT0a/s9PRCNTR0H2Vp8GcsXQEgqiqzWfg6aAwyg+Vps5Fmds7AOX32B1UqlfgXuD81UBJxO14dfdsPxJQWeaJizAaeAY8C1ZvldrKcbsmUXkj8fjb7JBUPuAwSi75DLIbhMSS2Pfz0G4iOIEcALFSeC42sz47RKuR/z/xG+jxx12KvRLgmwDVqoEaZ1GUsux06uknF7FVbxITgBXEa6huAZcR7iEcIEko5T5W+WxI99wEYtYRFP4H6As0BzXUft8AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalWallpaper);
export default __webpack_public_path__ + "static/media/Normal-wallpaper.a1247a1c9b3f6951e6a884c0c37caff1.svg";
export { ForwardRef as ReactComponent };